export default {
  search_all: 'Search all Services',
  explore_docs: 'Explore Docs',
  products_features: 'Features',
  products_key_benefits: 'Key Benefits',
  products_typical_application: 'Typical Application',
  products_help_guides: 'Help & Guides',
  products_more_details: 'More Details',
  products_more_details_desc:
    'You can explore our documentation to know more about our services',
  products_more_try_now: 'Try Now',
  products_more_try_now_desc:
    'Log in to our platform now and experience the full range of services',
  products_more_contact_us: 'Contact Us',
  products_more_contact_us_desc:
    'Our experts will promptly respond to any issues you may have',
  no_search_result: 'No search results.',
  put_away: 'Put away',
  more: 'More',
};
